export default {
  note: {
    title: 'Note speciali:',
    description:
      'Faremo del nostro meglio per soddisfare le richieste, ma non possiamo apportare modifiche che influiscano sul prezzo.',
    placeholder: 'Aggiungi richiesta speciale',
  },
  buttons: {
    add: '+ Aggiungi articolo',
    update_item: 'Aggiorna',
    add_to_card: 'Aggiungi al carrello',
  },
  alcohol_warning: "Questo è un articolo con restrizione d'età.",
  caffeine_warning:
    'Contenuto elevato di caffeina. Non raccomandato per bambini, donne in gravidanza o in allattamento.{{value}}',
  error_messages: {
    product_unavailable: 'Esaurito!',
    item_not_added: "Impossibile aggiungere l'articolo. Riprova.",
  },
  success_messages: {
    item_added: 'Articolo aggiunto con successo',
  },
};
